define((require) => {
    'use strict';

    const _ = require('lodash');
    const SuggestItem = require('system/blocks/suggest/__item/suggest__item');

    return SuggestItem.extend('billing-registration__legal-suggestion', {
        onRender() {
            this._value = _.get(this.data, 'ogrn');
        },
    });
});
